import React from "react";
import { translate } from "../Services/translation";

const CheckoutDeliveryMethods = ({ deliveryMethods, selectedId, onChange }) => (
    <section className="checkout-info__container checkout__delivery-selection">
        {/* <div className="form__label">
            {translate('checkout.delivery.title')}
        </div>
        <div className="checkout__delivery-selection-container">
            {deliveryMethods &&
                deliveryMethods.map((method) => (
                    <label className="row no-margin" key={method.id}>
                        <label className="checkbox">
                            <input
                                type="radio"
                                name="deliveryMethods"
                                className="checkout-info__checkbox-radio"
                                value={method.id}
                                checked={method.id === selectedId}
                                onChange={() => onChange(method.id)}
                            />
                            <span></span>
                        </label>
                        <div className="columns">
                            {method.name} - {method.formattedPrice}
                        </div>
                    </label>
                ))}
        </div> */}
    </section>
);

export default CheckoutDeliveryMethods;
